module.exports = __webpack_public_path__ + "static/media/hugo_desktop_1.d11fb7c6.webp";